import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../containers/Home";

function useTabKey(key: string) {
	const { handlePageChange }: any = useContext(HomeContext);

	const [tabKey, setTabKey] = useState<any>(key);

	const handleTabChange = async (key: any) => {
		try {
			await handlePageChange();
			setTabKey(key);
			sessionStorage.setItem("main-tabkey", key);
		} catch {}
	};

	useEffect(() => {
		handleTabChange(key);
	}, [key]);

	return { tabKey, handleTabChange };
}

export default useTabKey;
